var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React, { useState } from 'react';
import { Callout, Collapsible, Flex, Image, Link, Modal, Text, Title } from '@homeexchange/design';
import i18n from '../../i18n';
import Utils from '../../utils/utils';
import Home from '../../models/Home.js';
import HomeEditPanelDescription from '../home/edit/HomeEditPanelDescription';
import HomeEditPanelFeatures from '../home/edit/HomeEditPanelFeatures';
import HomeEditPanelHouseAndBeds from '../home/edit/HomeEditPanelHouseAndBeds';
import HomeEditPanelPictures from '../home/edit/HomeEditPanelPictures';
import Transfert from '../../models/Transfert';
import moment from 'moment/moment';
var HomeStatusModal = function (_a) {
    var isOpen = _a.isOpen, onClose = _a.onClose, homeCompletionRate = _a.homeCompletionRate, isHomeActive = _a.isHomeActive, isCollection = _a.isCollection, GPValue = _a.GPValue, hasHomeCompletionTransfert = _a.hasHomeCompletionTransfert, showModalMissingInformation = _a.showModalMissingInformation, wasOffline = _a.wasOffline, homeSaved = _a.homeSaved, newCompletionRate = _a.newCompletionRate, handleSave = _a.handleSave, turnOnline = _a.turnOnline, home = _a.home;
    var withGPSlide = false;
    var _b = useState(false), showGPSlide = _b[0], setShowGPSlide = _b[1];
    var user = home === null || home === void 0 ? void 0 : home.get('user');
    var gpExpirationDate = ((!user.hasAlreadySubscribed() && user.get('user_information')) || {}).gp_reward_expiration_date;
    var scrollToElement = function (elementId) {
        var element = document.getElementById(elementId);
        if (element) {
            requestAnimationFrame(function () {
                element.scrollIntoView({
                    behavior: 'smooth',
                    block: 'start'
                });
            });
        }
    };
    var missingInformation = function () {
        var _a, _b;
        if (!home)
            return '';
        var homeDescription = home.get('descriptions')[0];
        var hasFilledDescription = ((_a = homeDescription === null || homeDescription === void 0 ? void 0 : homeDescription.description) === null || _a === void 0 ? void 0 : _a.length) > 0;
        var hasHomeFeatures = ((_b = home === null || home === void 0 ? void 0 : home.get('features')) === null || _b === void 0 ? void 0 : _b.length) > 0;
        var homeCapacity = (home === null || home === void 0 ? void 0 : home.get('capacity')) || 0;
        var homeImages = (home === null || home === void 0 ? void 0 : home.get('images')) || [];
        var result = '';
        switch (true) {
            case !hasFilledDescription:
                result = Utils.slugify(HomeEditPanelDescription.title);
                break;
            case !hasHomeFeatures:
                result = Utils.slugify(HomeEditPanelFeatures.title);
                break;
            case homeCapacity === 0:
                result = Utils.slugify(HomeEditPanelHouseAndBeds.title);
                break;
            case homeImages.length < 5:
                result = Utils.slugify(HomeEditPanelPictures.title);
                break;
            default:
                break;
        }
        return result;
    };
    var getModalContent = function () {
        var confirmActionText = '';
        var description = '';
        var title = '';
        var labelClosed = '';
        var collapsible = false;
        var callout = false;
        var calloutText = '';
        var isClosable = false;
        if (showModalMissingInformation) {
            title = i18n.t('common:popup-blocker.first-missing-informations.title');
            description = i18n.t('common:popup-blocker.first-missing-informations.text');
            confirmActionText = i18n.t('common:popup-blocker.first-missing-informations.button');
        }
        // Case 1: Home completion = 100, first home, and home is active
        else if (homeCompletionRate === Home.HOME_COMPLETED && !hasHomeCompletionTransfert) {
            title = i18n.t('home:funnel.homeCompletion.endScreen.home100.title');
            description = i18n.t('home:modale.homeEdit.homeOnline.body');
            labelClosed = i18n.t('home:funnel.homeCompletion.endScreen.calloutTitle', {
                nb: GPValue
            });
            collapsible = true;
            callout = false;
            withGPSlide = true;
            if (showGPSlide) {
                isClosable = true;
                confirmActionText = !user.isSubscriber()
                    ? i18n.t('global:global.activateMembership')
                    : i18n.t('global:global.cta.understood');
            }
            else {
                confirmActionText = i18n.t('home:funnel.homeCompletion.nextStep.cta');
            }
        } // Case 2: Home completion = 100, not first time (already given GP)
        else if (homeCompletionRate === Home.HOME_COMPLETED && hasHomeCompletionTransfert) {
            title = i18n.t('home:funnel.homeCompletion.endScreen.home100.title');
            description = i18n.t('home:modale.homeEdit.homeOnline.body');
            confirmActionText = i18n.t('global:global.cta.understood');
            labelClosed = i18n.t('home:funnel.homeCompletion.endScreen.calloutTitle', {
                nb: GPValue
            });
            collapsible = true;
            callout = false;
        }
        //Case 3: Home completion between 80 and 99, first home, and already online
        else if (homeCompletionRate >= Home.HOME_COMPLETION_RATE_80 &&
            homeCompletionRate < Home.HOME_COMPLETED &&
            !hasHomeCompletionTransfert) {
            var gpNumber = Transfert.getSponsoredTransferValue(Transfert.MOTIVE_FILLING_WRITE_HOME, user.get('has_godfather'));
            title = i18n.t('home:modale.homeEdit.firstHomeNot100.title', {
                nb: Home.HOME_COMPLETED - homeCompletionRate,
                gpNumber: gpNumber
            });
            confirmActionText = i18n.t('global:global.cta.understood');
            description = i18n.t('home:modale.homeEdit.firstHomeNot100.body', {
                nb: gpNumber
            });
            callout = true;
            collapsible = false;
            calloutText = i18n.t('home:global.toast.updatesSaved.online');
        }
        //Case 4: Home completion between 80 and 99, and already online
        else if (homeCompletionRate >= Home.HOME_COMPLETION_RATE_80 &&
            homeCompletionRate < Home.HOME_COMPLETED &&
            isHomeActive) {
            title = i18n.t('home:modale.homeEdit.homeOnline.updated.title');
            confirmActionText = i18n.t('global:global.cta.understood');
            description = i18n.t('home:modale.homeEdit.homeOnline.body');
            labelClosed = '';
            collapsible = false;
            callout = false;
        }
        // Default case
        else {
            title = i18n.t('home:modale.homeEdit.homeOnline.updated.title');
            description = i18n.t('home:modale.homeEdit.homeOnline.body');
            confirmActionText = i18n.t('global:global.cta.understood');
            labelClosed = i18n.t('home:funnel.homeCompletion.endScreen.calloutTitle', {
                nb: GPValue
            });
            callout = false;
        }
        return {
            title: title,
            description: description,
            confirmActionText: confirmActionText,
            labelClosed: labelClosed,
            collapsible: collapsible,
            callout: callout,
            calloutText: calloutText,
            isClosable: isClosable
        };
    };
    var modalContent = getModalContent();
    var title = modalContent.title, confirmActionText = modalContent.confirmActionText, description = modalContent.description, labelClosed = modalContent.labelClosed, collapsible = modalContent.collapsible, callout = modalContent.callout, calloutText = modalContent.calloutText, isClosable = modalContent.isClosable;
    return (React.createElement(React.Fragment, null,
        React.createElement(Modal, { title: "", areDividersVisible: false, isClosable: isClosable, onClose: isClosable ? onClose : null, confirmActionText: confirmActionText, isOpen: isOpen, onConfirmAction: function (e) { return __awaiter(void 0, void 0, void 0, function () {
                var elementId_1, error_1;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (!showModalMissingInformation) return [3 /*break*/, 2];
                            elementId_1 = missingInformation();
                            return [4 /*yield*/, onClose()];
                        case 1:
                            _a.sent();
                            if (elementId_1) {
                                setTimeout(function () {
                                    scrollToElement(elementId_1);
                                }, 0);
                            }
                            return [2 /*return*/];
                        case 2:
                            if (!(wasOffline &&
                                homeSaved &&
                                newCompletionRate &&
                                newCompletionRate >= Home.MINIMUM_FILLING_TO_CONTACT &&
                                turnOnline)) return [3 /*break*/, 7];
                            _a.label = 3;
                        case 3:
                            _a.trys.push([3, 6, , 7]);
                            if (!handleSave) return [3 /*break*/, 5];
                            return [4 /*yield*/, turnOnline(e, {}, { name: 'status', value: true })];
                        case 4:
                            _a.sent();
                            handleSave();
                            _a.label = 5;
                        case 5: return [3 /*break*/, 7];
                        case 6:
                            error_1 = _a.sent();
                            console.error('Failed to turn home online:', error_1);
                            return [3 /*break*/, 7];
                        case 7:
                            if (withGPSlide) {
                                if (!showGPSlide) {
                                    setShowGPSlide(true);
                                }
                                else {
                                    if (!user.isSubscriber()) {
                                        window.location.href = i18n.t('url:my-plan.url');
                                        e.preventDefault();
                                    }
                                    else {
                                        onClose();
                                    }
                                }
                                return [2 /*return*/];
                            }
                            onClose();
                            return [2 /*return*/];
                    }
                });
            }); } },
            React.createElement("div", { className: "modal-slide-container" },
                React.createElement("section", { className: "modal-slide slide-info ".concat(withGPSlide && (!showGPSlide ? 'active' : 'to-left')) },
                    React.createElement(Flex, { isFullWidth: true, direction: "column", alignItems: "center" },
                        React.createElement("div", { className: "mb-8" },
                            React.createElement(Image, { alt: "", src: "".concat(Utils.getAssetsDomain(), "/images/website/").concat(showModalMissingInformation
                                    ? 'common/listing-missing-information.svg'
                                    : (isCollection ? 'collection' : 'home') + '/home-edit-modal.svg') }))),
                    callout && (React.createElement("div", { className: "mb-8" },
                        React.createElement(Callout, { status: "success", hasIcon: true },
                            React.createElement(Text, null, calloutText)))),
                    React.createElement(Flex, { isFullWidth: true, gap: "2" },
                        React.createElement(Title, null, title),
                        React.createElement(Text, { size: "md", dangerouslySetInnerHTML: {
                                __html: description
                            } })),
                    collapsible && (React.createElement("div", { className: "mt-8" },
                        React.createElement(Collapsible, { labelClosed: labelClosed, labelOpen: labelClosed, openOn: "bottom", isHighlighted: true, isFullWidth: true },
                            React.createElement(Text, null, i18n.t('home:funnel.homeCompletion.endScreen.calloutDetails')),
                            !isCollection && GPValue > 150 && (React.createElement(Text, null, i18n.t('home:funnel.homeCompletion.endScreen.calloutAverageValue'))),
                            React.createElement(Text, null,
                                React.createElement(Link, { href: i18n.t('About-guestpoints-url'), color: "secondary", target: "_blank" },
                                    React.createElement("span", null, i18n.t('global:global.link.learnMoreGP')))))))),
                withGPSlide && (React.createElement("section", { className: "modal-slide slide-gp to-right ".concat(!showGPSlide ? 'to-right' : 'active') },
                    React.createElement(Flex, { isFullWidth: true, direction: "column", gap: "6" },
                        React.createElement(Flex, { isFullWidth: true, direction: "column", alignItems: "center" },
                            React.createElement("div", null,
                                React.createElement(Image, { alt: "Welcome Guestpoints", src: "".concat(Utils.getAssetsDomain(), "/images/website/migration/panel/guest_point_exchange_hd.svg") }))),
                        React.createElement(Title, null, i18n.t('home:modal.homeCompletion.home100.content.title', {
                            nb: Transfert.MOTIVES_VALUE[Transfert.MOTIVE_FILLING_WRITE_HOME]
                        })),
                        !user.isSubscriber() && (React.createElement(React.Fragment, null,
                            React.createElement(Text, { size: "lg", dangerouslySetInnerHTML: {
                                    __html: i18n.t('home:modale.homeEdit.home100.welcomeGP.subheader', {
                                        date: moment(gpExpirationDate).format('L')
                                    })
                                } }))),
                        user.get('has_godfather') && (React.createElement(Callout, { status: "neutral" },
                            React.createElement(Text, { dangerouslySetInnerHTML: {
                                    __html: i18n.t('global:modale.home100.welcomeGP.referralCallout', {
                                        nb: Transfert.SPONSORED_REWARD_VALUE[Transfert.MOTIVE_FILLING_WRITE_HOME]
                                    })
                                } }))))))))));
};
export default HomeStatusModal;
